export enum PlanType {
  Family = 1,
  Customize = 2,
}
